module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 16.547225a0.mp3";